import { ValidationResult } from '../../../../../../ui/gzForm/formField/types/form-validator';
import { translateFn } from '../../../../../../utils/translator.helper';

// see sha256Multiple from ExtJs
export function sha256Multiple(value: string): ValidationResult {
  const elements = value.split(', ');
  let isValid = true;

  elements.forEach(element => {
    if (/^([a-f0-9]{64})$/i.test(element) === false) {
      isValid = false;
      return false;
    }
  });

  if (isValid) {
    return { valid: true };
  }

  return {
    valid: false,
    error: translateFn('Invalid SHA256 hash. Hashes must be separated by commas.'),
  };
}
